// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".usage-metric-chart .z-chart-wrapper[data-v-dc823f24]{--vis-axis-domain-color:transparent;--vis-dark-axis-domain-color:transparent;--vis-axis-tick-color:transparent;--vis-dark-axis-tick-color:transparent;--vis-stacked-bar-stroke-color:#16181d;--vis-stacked-bar-stroke-width:2px;--vis-crosshair-circle-stroke-opacity:0;--vis-crosshair-circle-fill-opacity:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
